/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Button from 'components/button';
import Notice from 'components/notice';
import { removeScheduledChanges } from 'state/subscriptions/actions';
import { getCurrentKioskId } from 'state/current-kiosk/selectors';
import { successNotice } from 'state/notices/actions';

const ScheduledChangesNotice = ({ subscriptionId, ...props }) => {
    const [requesting, setRequesting] = useState(null);

    const handleRemoveScheduledChanges = async () => {
        setRequesting(true);
        props
            .removeScheduledChanges(subscriptionId)
            .then(() => props.successNotice('Your pending changes to your Customer Self Checkout subscription have been cancelled.'))
            .catch((e) => console.log(e))
            .finally(() => setRequesting(false));
    };

    return (
        <Notice
            text='You have pending changes to your Customer Self Checkout subscription.'
            subText='These will take effect at the end of the current payment period.'
            showDismiss={false}
        >
            <Button disabled={requesting || !subscriptionId} secondary onClick={handleRemoveScheduledChanges}>
                Cancel scheduled changes
            </Button>
        </Notice>
    );
};

export default connect((state) => ({ subscriptionId: getCurrentKioskId(state) }), {
    removeScheduledChanges,
})(ScheduledChangesNotice);
